import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Toolbar of a mission configuration section: back, title + completion status, complete/reopen, add.
 */
@Component({
    selector: 'app-section-toolbar',
    templateUrl: './section-toolbar.component.html',
    styleUrls: ['./section-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionToolbarComponent {
  @Input() sectionTitle: string;
  @Input() isComplete = false;
  // Hide the complete/reopen action (sections without status)
  @Input() hasStatus = true;
  // Label of the add action; no add action when empty
  @Input() addLabel: string;
  @Output() back = new EventEmitter<void>();
  @Output() toggleStatus = new EventEmitter<void>();
  @Output() add = new EventEmitter<void>();
}
